import { lazy } from 'react';

const CustomModals = lazy(() => import('./CustomModals'));

export default CustomModals;
